import { render, staticRenderFns } from "./Morph.vue?vue&type=template&id=7d91d5c4&scoped=true&"
import script from "./Morph.vue?vue&type=script&lang=js&"
export * from "./Morph.vue?vue&type=script&lang=js&"
import style0 from "./Morph.vue?vue&type=style&index=0&id=7d91d5c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d91d5c4",
  null
  
)

export default component.exports